import * as types from './types'

export default {
  [types.LAST_URL] (state, value) {
    state.lastUrl = value
  },

  [types.PATIENT_PRIVACY_URL] (state, value) {
    state.patientPrivacyUrl = value
  },

  [types.PATIENT_PRIVACY_URL_LABEL] (state, value) {
    state.patientPrivacyUrlLabel  = value
  },

  [types.SIDENAV_LINKS] (state, value) {
    state.sidenavLinks = value
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/website/mutations.js
// module id = null
// module chunks = 